<template>
	<div class="row">
		<div class="col-12">
			<div class="flex-table">
				<list-item
					v-for="company in companies"
					:key="company.id"

					v-bind:class="!company.active ? 'invalid rounded' : ''"
					v-on:click="show(company)"
				>
					<template slot="title">
						{{company.name}}
					</template>

					<template slot="center">
						<div class="flex-table--header-content-offset">
							<div class="btn-group">
								<svg-image
									src="/svg/default/more.svg"
									width="20px"
									height="25px"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								></svg-image>
								<div class="dropdown-menu dropdown-menu-right">
									<svg-image
										:src="'/svg/default/' + (!company.active ? 'tick' : 'close') + '.svg'"
										width="20px"
										height="20px"
										:highlight="!company.active ? 'success' : 'negative'"
										class="dropdown-item"
										:auto_hover="true"
										:spaced="true"
										@click="toggleDisable(company)"
									>
										<span v-bind:class="!company.active ? 'text-success' : 'text-danger'">{{!company.active ? 'Enable' : 'Disable'}}</span>
									</svg-image>

									<svg-image
										src="/svg/default/bin.svg"
										width="20px"
										height="20px"
										highlight="negative"
										class="dropdown-item"
										:auto_hover="true"
										:spaced="true"
										@click="deleteCompany(company)"
									>
										<span class="text-danger">Permanently delete</span>
									</svg-image>
								</div>
							</div>
						</div>
					</template>
				</list-item>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "CompanyIndexPage",
		props: {
			companies: {
				type: Array,
				required: true
			},

			show_url: {
				type: String,
				required: true
			},
			delete_url: {
				type: String,
				required: true
			},
			disable_url: {
				type: String,
				required: true
			}
		},

		methods: {
			show(company){
				window.location.href = this.show_url.replace('?', company.id);
			},
			toggleDisable(company){
				axios.post(this.disable_url.replace('?', company.id))
					.then(() => window.location.reload());
			},
			deleteCompany(company){
				if (!confirm('Are you sure you want to permanently delete "' + company.name + '"?\n\nWARNING: This cannot be undone'))
					return;

				axios.delete(this.delete_url.replace('?', company.id))
					.then(() => window.location.reload())
					.catch(error => {
                        Vue.$toast.open({
                            message: `Something went wrong! Contact support: <li>${error.message}</li>`,
                            type: 'error'
                        });
                    });
			}
		}
	}
</script>
